"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));

var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _en2 = _interopRequireDefault(require("sk-ui/lib/locale/lang/en"));

var _zhCN2 = _interopRequireDefault(require("sk-ui/lib/locale/lang/zh-CN"));

var _util = require("sk-ui/lib/utils/util.js");

var _vue = _interopRequireDefault(require("vue"));

var _vueI18n = _interopRequireDefault(require("vue-i18n"));

var _index = _interopRequireDefault(require("./en/index.js"));

var _index2 = _interopRequireDefault(require("./zh/index.js"));

// element-ui         公共ui支持英文
// element-ui lang  公共ui支持中文
// sk-ui         公共ui支持英文
// sk-ui lang  公共ui支持中文
// 项目英文库
// 项目中文库
_vue["default"].use(_vueI18n["default"]);

var messages = {
  en: (0, _objectSpread2["default"])({}, (0, _util.extend)(true, _en["default"], _en2["default"], _index["default"])),
  zh: (0, _objectSpread2["default"])({}, (0, _util.extend)(true, _zhCN["default"], _zhCN2["default"], _index2["default"]))
};
var i18n = new _vueI18n["default"]({
  locale: _jsCookie["default"].get('language') || process.env.LANGUAGE,
  // 从缓存中获取本地支持语言类别，默认是中文
  messages: messages // set locale messages          // 语言库

});
var _default = i18n;
exports["default"] = _default;